export default __webpack_public_path__ + "static/media/onboarding_snap_save_3.eb862e36.png";